import { Box, makeStyles, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    boxPlaceholder: {
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center"
    },
    img: {
        width: "108px"
    },
    text: {
        color: "rgba(238, 238, 238, 0.3)"
    }
}))
export const PlaceholderClassify = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Box className={classes.boxPlaceholder}>
            <img src="/static/img/icons/newUnitIcon.svg" alt="new unit icon" className={classes.img} />
            <Typography variant="h4" gutterBottom className={classes.text}>
                {t("questionUnits_addNew")}
            </Typography>
        </Box>
    )
}